import { Grid, Typography } from "@mui/material"
import { Box } from "@mui/system"
import ClpButton from "components/Button"
import React from "react"

const ExternalSendButton = ({ buttonFeedbackResult, onAddSubmit, t }) => {
  return (
    <Grid pt={5} sx={{ m: "auto" }} item md={8} display="flex" justifyContent="center">
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box mb={2}>
          <ClpButton onClick={onAddSubmit} color="success" result={buttonFeedbackResult} variant="contained">
            {t("global.send_report", "Send report")}
          </ClpButton>
        </Box>
        <Typography textAlign="center" variant="bodySmall">
          {t(
            "issuereports.when_you_submit_the_report",
            "When you submit the report, the work order is marked as completed and a notification is sent to the requester"
          )}
        </Typography>
      </Box>
    </Grid>
  )
}

export default ExternalSendButton
